import React, { SVGProps } from 'react'

const FourImagesIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
    <path d="M.892.87H9.54v8.647H.892zM10.462.87h8.647v8.647h-8.647zM.892 10.485H9.54v8.647H.892zM10.462 10.485h8.647v8.647h-8.647z" />
  </svg>
)

export default FourImagesIcon
